export const CIRCLE_SIZE = 56;
export const BORDER_WIDTH = 4;
export const PADDING = 4;
export const BLUR_RADIUS = 16;
